import { render, staticRenderFns } from "./NpTable.vue?vue&type=template&id=74e01473"
import script from "./NpTable.vue?vue&type=script&lang=ts"
export * from "./NpTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports